import React from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import AnswerChoice from '../../AnswerChoice';
import { P } from '@osmosis/react-ui/components/Text';
import { TrueFalseData } from '../../../../types/quiz';
import { Flex } from '@osmosis/react-ui/components/Box';

/**
 * TrueFalse.
 */
const TrueFalse = () => {
  const { currentItem } = useQuizContext();

  return (
    <Flex flexDirection="column">
      <P
        textAlign="justify"
        dangerouslySetInnerHTML={{
          __html: (currentItem?.data as TrueFalseData)?.question,
        }}
      />

      <AnswerChoice />
    </Flex>
  );
};

export default TrueFalse;
